// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".list-unstyled span[data-v-7632d9b4]{font-size:.9em}.list-unstyled i[data-v-7632d9b4]{top:.4em}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
